import { render, staticRenderFns } from "./BranchDetails.vue?vue&type=template&id=6d1a59d8&scoped=true"
import script from "./BranchDetails.vue?vue&type=script&lang=js"
export * from "./BranchDetails.vue?vue&type=script&lang=js"
import style1 from "./BranchDetails.vue?vue&type=style&index=1&id=6d1a59d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1a59d8",
  null
  
)

export default component.exports